import { render } from "./ThumbPerfil.vue?vue&type=template&id=6591830a&scoped=true&ts=true"
import script from "./ThumbPerfil.vue?vue&type=script&lang=ts"
export * from "./ThumbPerfil.vue?vue&type=script&lang=ts"

import "./ThumbPerfil.vue?vue&type=style&index=0&id=6591830a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6591830a"]])

export default __exports__